import { Trans, useTranslation } from 'react-i18next'

import { PkgReqTypeEnum } from '@/api/package-req/types/PkgReq'
import { ConfirmDialog } from '@/components/ConfirmDialog'
import FailIcon from '@/components/icons/fail.svg?react'
import { TransKey } from '@/i18n'

const ACTION_TYPE_I18N_KEY: Partial<Record<PkgReqTypeEnum, TransKey>> = {
  [PkgReqTypeEnum.PhotoRequest]: 'pkgReqs.photo',
  [PkgReqTypeEnum.ShrinkRequest]: 'pkgReqs.shrink',
  [PkgReqTypeEnum.ReturnRequest]: 'pkgReqs.return',
  [PkgReqTypeEnum.UniteRequest]: 'pkgReqs.unite',
}

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  actionType: PkgReqTypeEnum | undefined
  isLoading?: boolean
}

export const CancelPkgReqConfirmDialog = ({ isOpen, onClose, onConfirm, actionType, isLoading = false }: Props) => {
  const { t } = useTranslation()

  const isReturnRequest = actionType === PkgReqTypeEnum.ReturnRequest

  const title = isReturnRequest
    ? t('pkgReqs.cancelReturnTitle')
    : t('pkgReqs.cancelRequestTitle', { action: actionType ? t(ACTION_TYPE_I18N_KEY[actionType]!) : '' })
  const content = isReturnRequest ? <Trans i18nKey='pkgReqs.cancelReturnContent' /> : t('pkgReqs.cancelRequestContent')
  const confirmText = isReturnRequest ? t('pkgReqs.cancelReturnConfirm') : t('pkgReqs.cancelRequestConfirm')
  const cancelText = isReturnRequest ? t('pkgReqs.cancelReturnClose') : t('pkgReqs.cancelRequestClose')

  return (
    <ConfirmDialog
      isOpen={isOpen}
      Icon={FailIcon}
      onConfirm={onConfirm}
      confirmLoading={isLoading}
      onClose={onClose}
      confirmText={confirmText}
      cancelText={cancelText}
      title={title}
      content={content}
    />
  )
}
